"use client";

import { useState } from "react";
import { PasswordField } from "@/components/PasswordField";
import { ServerTool } from "@/components/ServerTool";
import { outputName } from "@/lib/files";
import { getTool } from "@/lib/tools";

const tool = getTool("protect-pdf")!;

/** Protect PDF (Phase 5, server): qpdf adds an open password (AES-256). */
export function ProtectPdfTool() {
  const [password, setPassword] = useState("");
  const [again, setAgain] = useState("");
  const mismatch = again !== "" && again !== password;
  return (
    <ServerTool
      tool={tool}
      job="protect"
      options={{ password }}
      ready={password !== "" && password === again}
      button="Protect PDF"
      result={(file, blob) => ({
        blob,
        name: outputName(file.name, "protected", "pdf"),
        detail: "Opens only with your password (AES-256)",
      })}
    >
      <PasswordField
        label="Password"
        value={password}
        onChange={setPassword}
        hint="Anyone opening the PDF will need it. We can't recover it, so keep it somewhere safe."
      />
      <PasswordField label="Type it again" value={again} onChange={setAgain} />
      {mismatch && (
        <p role="alert" className="text-sm font-medium text-destructive">
          The two passwords are different.
        </p>
      )}
      {password.length > 0 && password.length < 6 && (
        <p className="text-sm text-ink">
          Tip: a longer password (8 or more characters) is much harder to guess.
        </p>
      )}
    </ServerTool>
  );
}
